import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const RecommendationSectionDisplay = ({ reasonForSuggestion }) => {
  const intl = useIntl();
  if (!reasonForSuggestion) {
    return null;
  }

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-succession-border">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <svg className="w-6 h-6 text-succession-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-succession-text-primary">
              {intl.formatMessage({ id: 'succession.profile_drawer.recommendation_section_display.why_this_match' })}
            </h3>
            <p className="text-sm text-succession-text-muted mt-1">
              {intl.formatMessage({ id: 'succession.profile_drawer.recommendation_section_display.recommendation_rationale' })}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6">
        <div className="text-sm text-succession-text-primary leading-relaxed whitespace-pre-wrap bg-succession-bg-primary rounded-lg p-5 border border-succession-border">
          {reasonForSuggestion}
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-3 bg-succession-bg-primary border-t border-succession-border">
        <div className="flex items-center text-xs text-succession-text-muted">
          <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {intl.formatMessage({ id: 'succession.profile_drawer.recommendation_section_display.algorithmically_matched' })}
        </div>
      </div>
    </div>
  );
};

RecommendationSectionDisplay.propTypes = {
  reasonForSuggestion: PropTypes.string,
};

export default RecommendationSectionDisplay;

